import './dark-mode.scss'
import * as React from 'react'

const DarkMode: React.FC = () => {
  return null
}
export default DarkMode
